import { useParams } from "react-router-dom";
import ResourceProtectedRoute from "./ResourceProtectedRoute";

const ProtectedCampaignRoute = ({ children }) => {
  const { campaignId } = useParams();
  return (
    <ResourceProtectedRoute
      resourceType="campaign"
      resourceId={campaignId}
      fallbackPath="/home"
    >
      {children}
    </ResourceProtectedRoute>
  );
};

export default ProtectedCampaignRoute;
